import { createMergeReducer } from '../utils/reducer'

export type StringIdToString = {
  [stringId: string]: string | undefined
}

export const reducer = createMergeReducer(
  t => t.strings,
  {} as StringIdToString
)
